import { Select, IconLoader, Autocomplete } from '@ui/src';
import { OverviewTopupSidepanelTypes } from './types';
import TopUpInstructionItem from './top-up-instruction';

import cn from './overview-topup.module.css';

let timeout: NodeJS.Timeout;

const OverviewTopupSidepanel = ({
  selectedTopUpId,
  setSelectedTopUpId,
  topUpOptions,
  topUpCurrency,
  setTopUpCurrency,
  currencies,
  topUpAccount,
  setTopUpAccount,
  topUpAccounts,
  instructionsIsLoading,
  topUpInstrusctions,
  getTopUpInstructionPdf,
  pdfDownloadInProgress,
  selectedInstructionType,
  onSearchTopUp,
  searchInProgress,
  nextPageIsLoading,
  topUpOptionsPagination,
  searchText,
  setSearchText,
}: OverviewTopupSidepanelTypes) => (
  <>
    <div
      className={cn.topupRowWrapper}
      style={{ zIndex: 10, position: 'relative' }}
    >
      <Autocomplete
        name="top-up"
        value={selectedTopUpId}
        onChange={(e) => {
          setSelectedTopUpId(e.target.value as string);
        }}
        list={topUpOptions?.map((item) => ({
          name: item.companyName,
          value: item.id,
        }))}
        onSearch={(e) => {
          clearTimeout(timeout);
          setSearchText(e);

          timeout = setTimeout(() => {
            onSearchTopUp({
              text: e,
            });
          }, 500);
        }}
        placeholder="Select the Bank from which the top-up will be made"
        title="Select the Bank from which the top-up will be made"
        isLoading={searchInProgress && !nextPageIsLoading}
        onInfinateScroll={() =>
          onSearchTopUp({
            text: searchText || '',
            cursor: topUpOptionsPagination?.endCursor,
          })
        }
        nextPageIsLoading={nextPageIsLoading}
        hasNextPage={topUpOptionsPagination?.hasNextPage}
        withClearButton
        withInfiniteScroll
        fullWidth
      />
    </div>
    <div
      className={cn.topupRowWrapper}
      style={{ zIndex: 9, position: 'relative' }}
    >
      <Select
        name="currency"
        value={topUpCurrency}
        onChange={(e) => setTopUpCurrency(e.target.value as string)}
        list={currencies}
        placeholder="Select top-up сurrency"
        title="Select top-up сurrency"
        withClearButton
        fullWidth
      />
    </div>
    <div
      className={cn.topupRowWrapper}
      style={{ zIndex: 8, position: 'relative' }}
    >
      <Select
        name="account"
        value={topUpAccount}
        onChange={(e) => setTopUpAccount(e.target.value as string)}
        list={topUpAccounts?.map((item) => ({
          name: `${item.description} (${item.account.fullNumber})`,
          value: item.accountId,
        }))}
        placeholder="Select account"
        title="Select a top-up account"
        disabled={Boolean(!topUpAccounts)}
        withClearButton
        fullWidth
      />
    </div>
    {instructionsIsLoading && (
      <div className={cn.instructionsLoader}>
        <IconLoader />
      </div>
    )}
    {topUpInstrusctions && !instructionsIsLoading && (
      <div className={cn.topupInstructionsWrapper}>
        {topUpInstrusctions.items.map((item, index) => (
          <TopUpInstructionItem
            // eslint-disable-next-line react/no-array-index-key
            key={`${item.paymentType}-${index}`}
            instruction={item}
            index={index}
            getTopUpInstructionPdf={getTopUpInstructionPdf}
            pdfDownloadInProgress={pdfDownloadInProgress}
            selectedInstructionType={selectedInstructionType}
          />
        ))}
        {topUpInstrusctions && !topUpInstrusctions.items.length && (
          <div className={cn.emptyMessage}>No Top-Up Instructions yet</div>
        )}
      </div>
    )}
  </>
);

export default OverviewTopupSidepanel;
